import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoadingService } from '@services/loading.service';

import { SKIP_LOADING } from './skip-loading.token';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService);

  intercept(request: HttpRequest<string | object>, next: HttpHandler): Observable<HttpEvent<string | object>> {
    if (request.method !== 'GET' || request.context.get(SKIP_LOADING)) {
      return next.handle(request);
    }

    this.loadingService.show();

    return next.handle(request).pipe(finalize(() => this.loadingService.hide()));
  }
}
